module.exports = __webpack_public_path__ + "img/department_icon7.f3620d14.png";